var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgItemDimensioning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M12.9 22.8c-.1 0-.2 0-.3-.1l-7.3-4.2V9.8l.3-.2q.3-.15.6 0l7.4 4.4v8.1q0 .3-.3.6c-.2.1-.3.1-.4.1m-6.6-4.9 6.2 3.6v-7l-6.2-3.7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "m13 14.9-7.7-4.6v-.6l.3-.1L13 5.2l7.6 4.4v.4c0 .2-.1.4-.3.5zM6.8 10l6.3 3.7 6.3-3.7L13 6.4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M16.4 12.7c-.1 0-.2 0-.3-.1L9.3 8.2c-.2-.1-.3-.4-.1-.7.2-.2.5-.3.7-.2l6.8 4.4c.2.1.3.5.2.7-.2.2-.4.3-.5.3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M17.5 14.5c-.2 0-.3-.1-.4-.3s0-.5.2-.7l2.7-1.4c.2-.1.5 0 .7.2.1.2 0 .5-.2.7l-2.7 1.4c-.1.1-.2.1-.3.1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9A39",
  d: "M19.9 21.1c-.2 0-.3-.1-.4-.2-.1-.2-.1-.5.1-.7l2-1.3v-2.4c0-.3.2-.5.5-.5s.5.2.5.5v2.9L20.1 21s-.1.1-.2.1M6.1 21.1c-.1 0-.2 0-.3-.1l-2.5-1.6v-2.9c0-.3.2-.5.5-.5s.5.2.5.5v2.4l2 1.3c.2.2.3.5.1.7.1.1-.1.2-.3.2M15.3 5.5c-.1 0-.2 0-.2-.1L13 4.3l-2.2 1.2c-.2.1-.5 0-.7-.2-.1-.2 0-.5.2-.7L13 3.1l2.6 1.4c.2.1.3.4.2.7-.1.2-.3.3-.5.3"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M13.2 22.8c-.1 0-.2 0-.3-.1q-.3-.15-.3-.6V14l7.3-4.3q.3-.15.6 0t.3.6v8.2l-7.2 4.3c-.1-.1-.3 0-.4 0m.3-8.2v7l6.2-3.7v-7zm6.8 3.5"
})));
export default SvgItemDimensioning;